import { useState, useEffect } from 'react';
import { Container, InputUnit, ReadOnlyValue, InputContainer, ContainerSP, ContainerState } from './styles'
import { NumberInput } from '../styles';
// import State from '../State';
// import OperationModeTwo from '../OperationModeTwo';
import { State, OperationModeTwo } from '../../Components';

/**
 * Componente para o Card
 * @returns {ReactComponentElement} 
 */
const CardVariable = ({VariableName, ReadOnly, VariableValue, VariableUnit, hasSP, SP, active, addComand, comandId, fatherName, 
    hasState, state, StateComand, stateName, type, isNewValue, isNewState }) => {
    const [currentValue, setCurrentValue] = useState(VariableValue !== null ? VariableValue : 0);
    const [currentsp, setCurrentSp] = useState(SP !== null ? SP : 0);
    const [selectedUnit, setSelectedUnit] = useState(VariableUnit);
    const [currentState, setCurrentState] = useState(false);

    useEffect(() => {
        setCurrentValue(VariableValue !== null ? VariableValue : 0);
        setCurrentSp(SP !== null ? SP : 0)
        setCurrentState(parseInt(state) === 1);
        setSelectedUnit(VariableUnit)
    },[VariableValue, SP, state, VariableUnit]);

    // Função para construir o comando e adicionar a lista
    const ComandConstructor = (comandId, value, oldvalue, childName, cancelComand, type) => {
        let newname = fatherName+'/'+childName
        addComand([comandId, value], oldvalue, newname, cancelComand, type);
    }

    const ComandConstructor2 = (comandId, value, oldvalue, childName, cancelComand, type) => {
        let newname = !type ? fatherName+'/'+childName : fatherName;
        addComand([comandId, value], oldvalue, newname, cancelComand, type);
    }

    // Método para alterar o state
    const changeState = (newState) => {
        ComandConstructor(StateComand, newState, state, stateName,
            () => {setCurrentState(parseInt(state) === 1)}, 'state');
        setCurrentState(newState);
    }
    // Método para alterar o state
    const changeStateVariable = (newState) => {
        ComandConstructor2(comandId, newState, VariableValue, VariableName, () => {setCurrentValue(VariableValue)}, 'state');
        setCurrentValue(newState);
    }

    // Método para alterar o modo de operação
    const changeOperationMode = (newState) => {
        ComandConstructor2(comandId, newState, VariableValue, VariableName, () => {setCurrentValue(VariableValue)}, 'modo');
        setCurrentValue(newState);
    }

    return (
        <Container>
            {ReadOnly?
            <InputContainer $Active={type === 'state' || type === 'operation'} onClick={(e) => type === 'state' || type === 'operation'? e.stopPropagation() : null}>
                {
                    type === 'state'?
                        <State isNewValue={isNewValue} State={parseInt(currentValue)=== 1} onChange={(newState) => changeStateVariable(newState)}/>
                    :
                    type === 'operation'?
                        <OperationModeTwo isNewValue={isNewValue} State={parseInt(currentValue) || parseInt(currentValue) === 0 ? parseInt(currentValue) : currentValue} 
                            onChange={(newState) => changeOperationMode(newState)}/>
                    :
                    <>
                        <ReadOnlyValue $active={active}>{currentValue}</ReadOnlyValue>
                        <InputUnit $active={active}>{VariableName +' (' +selectedUnit+')'}</InputUnit>
                    </>
                }
            </InputContainer>
            :
            <InputContainer $Active={active} onClick={(e) => e.stopPropagation()}>
                <NumberInput value={currentValue} 
                    isNewValue={isNewValue}
                    scale={1.2}
                    // onBlur={() => ComandConstructor(Pumpvazao.current?.variavel.id, currentValue, Pumpvazao.current?.variavel.valor,
                    // Pumpvazao.current?.variavel.name, () => setCurrentValue(Pumpvazao.current?.variavel.valor !== null ? Pumpvazao.current?.variavel.valor : 0))} 
                    type="number"
                    onChange={(e) => {setCurrentValue(e.target.value);}}/>
                <InputUnit>{VariableName +' (' +selectedUnit+')'}</InputUnit>
            </InputContainer>}
            
            {hasState?
                <ContainerState $Active={active} onClick={(e) => e.stopPropagation()}>
                    <State isNewValue={isNewState} State={currentState} onChange={(newState) => changeState(newState)}/>
                </ContainerState>
            :<></>}

            {hasSP ?
                <ContainerSP $Active={active} onClick={(e) => e.stopPropagation()}>
                    <NumberInput value={currentsp}
                        isNewValue={isNewValue}
                        scale={1.2}
                        onBlur={() => ComandConstructor(comandId ,currentsp, SP, 'SP', () => {setCurrentSp(SP !== null ? SP : 0)})} 
                        type="number" 
                        onChange={(e) => {setCurrentSp(e.target.value)}}/>
                    <InputUnit $active={active}>{selectedUnit}</InputUnit>
                </ContainerSP>
            : <></>}
        </Container>
    );
}

export default CardVariable;
